import React from 'react';
import StaffLogin from '@/components/StaffLogin';

const AdminLogin = () => {
  return (
    <StaffLogin
      role="admin"
      title="Admin Dashboard Login"
      description="Enter your admin password to access the dashboard"
      redirectTo="/admin"
    />
  );
};

export default AdminLogin;